import { NARROW_PROBLEM_WIDTH } from '@gmm/problem';

import { MOBILE_MARGIN_PX } from '../../constants';

// Preserve the pre-change relationship for naturally wide help. This is the
// total panel-to-canvas delta, not a literal scrollbar measurement.
const NATURAL_HELP_PANEL_WIDTH_DELTA = 20;
// At the minimum width, reserve scrollbar space in addition to the panel's
// border-box padding so narrow help has its full minimum canvas width.
const MIN_HELP_SCROLLBAR_WIDTH_BUDGET = 20;

export const SHOW_ANSWER_HORIZONTAL_PADDING = 20;
export const HELP_PANEL_PADDING = 5;

const MIN_MODAL_WIDTH = NARROW_PROBLEM_WIDTH - 2 * MOBILE_MARGIN_PX;
const MIN_HELP_PANEL_WIDTH =
  MIN_MODAL_WIDTH - 2 * SHOW_ANSWER_HORIZONTAL_PADDING;
const MIN_HELP_CANVAS_WIDTH =
  MIN_HELP_PANEL_WIDTH -
  MIN_HELP_SCROLLBAR_WIDTH_BUDGET -
  2 * HELP_PANEL_PADDING;

interface HelpSizing {
  helpCanvasWidth: number;
  helpPanelWidth: number;
}

export const getHelpSizing = (measuredHelpWidth: number): HelpSizing => {
  const helpCanvasWidth = Math.max(measuredHelpWidth, MIN_HELP_CANVAS_WIDTH);
  const helpPanelWidth = Math.max(
    helpCanvasWidth + NATURAL_HELP_PANEL_WIDTH_DELTA,
    MIN_HELP_PANEL_WIDTH
  );

  return { helpCanvasWidth, helpPanelWidth };
};
